import { Component, OnInit } from '@angular/core';
import { PageMixin } from 'src/app/services/mixins/page.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { InfoService } from 'src/app/services/info.service';
import { Router } from '@angular/router';
import { LangService } from 'src/app/services/lang.service';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ClientService } from '../../../services/client.service';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'add-to-homescreen',
    templateUrl: './add-to-homescreen.component.html',
})
export class AddToHomescreenComponent extends PageMixin(BaseComponent) implements OnInit {
    private activeTab: string = 'ios';

    public constructor(
        public page: PageService,
        protected translate: TranslateService,
        protected client: ClientService,
        public deviceService: DeviceDetectorService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,
        public lang?: LangService,
    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.lang!.getLang().then((): Promise<any> => this.createTitle());
    }

    public tab(name: string): void {
        this.activeTab = name;
    }

    get img(): string {
        return `/img/pocket-mobile_${this.activeTab}.jpg`;
    }

    /**
     * Create page title and meta
     * @return Promise<any>
     */
    private createTitle(): any {
        this.translate.get('web.title_about_us').subscribe((): void => {
            const trans = this.translate.instant('web.title_add_to_homescreen');
            const client = this.client.getVName();
            this.setTitle(
                {
                    title: `${trans} | ${client}`,
                    description: this.translate.instant('web.description_add_to_homescreen'),
                },
                true,
            );
        });
    }
}
